// extracted by mini-css-extract-plugin
export default {"container":"mN-z","dimension":"nN-z","dimensionLabels":"oN-z"};